import {useMemo, useState} from 'react'
import {Box, Flex, Table} from '@binance/uikit'
import useRouter from 'hooks/useRouter'
import useTradeHistoryDataPrivider from 'hooks/useTradeHistoryDataProvider'
import useUserLoginStatus from 'hooks/useUserLoginStatus'
import useSymbolInfo from 'hooks/useSymbolInfo'
import {getDateRange} from 'utils/common'
import ToolBar from './ToolBar'
import {NoData} from './NoData'

const getTitles = i18n => [
  {
    title: i18n['tradeHistory-timeTitle'] || 'Time',
    key: 'insertTime',
    direction: 'start',
    width: 158
  },
  {
    title: i18n['tradeHistory-symbolTitle'] || 'Symbol',
    key: 'symbol',
    direction: 'start',
    width: 110
  },
  {
    title: i18n['tradeHistory-sideTitle'] || 'Side',
    key: 'side',
    direction: 'start',
    width: 110
  },
  {
    title: i18n.priceTitle || 'Price',
    key: 'price',
    direction: 'start',
    width: 110
  },
  {
    title: i18n['tradeHistory-quantityTitle'] || 'Quantity',
    key: 'qty',
    direction: 'start',
    width: 110
  },
  {
    title: i18n['tradeHistory-feeTitle'] || 'Fee',
    key: 'fee',
    direction: 'start',
    width: 110
  },
  {
    title: i18n['tradeHistory-realizedProfitTitle'] || 'Realized Profit',
    key: 'realizedProfit',
    width: 110
  }
]

export default function TradeHitoryPane ({i18n, focus}) {
  const {start, end} = getDateRange()
  const [startDate, setStartDate] = useState(start)
  const [endDate, setEndDate] = useState(end)
  const router = useRouter()
  const {symbol} = router.query
  const isLogin = useUserLoginStatus()
  const {symbolInfo} = useSymbolInfo()
  const {data = {}, hasMore, loadMore} = useTradeHistoryDataPrivider(
    isLogin,
    symbol,
    startDate,
    endDate,
    focus,
    symbolInfo
  )
  return useMemo(
    () =>
      isLogin ? (
        <Flex width="100%" flexDirection="column">
          <ToolBar
            i18n={i18n}
            activeColor="w"
            handleDateChange={({startTime, endTime}) => {
              setStartDate(startTime)
              setEndDate(endTime)
            }}
          />
          <Box flex={1}>
            <Table
              data={data}
              title={getTitles(i18n)}
              flex={1}
              nodata={isLogin ? NoData('trade history') : null}
              hasMore={hasMore}
              loadMoreRows={loadMore}
            />
          </Box>
        </Flex>
      ) : null,
    [data, hasMore, i18n, isLogin, loadMore]
  )
}
